var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmCashBlackWhite = function SvgPmCashBlackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.75,
    width: 32.5,
    height: 20.5,
    rx: 3.25,
    stroke: "#08031D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 14.75a1.5 1.5 0 0 0-1.35-.75h-1.5a1.5 1.5 0 0 0 0 3h1.5a1.5 1.5 0 0 1 0 3h-1.5a1.5 1.5 0 0 1-1.35-.75M17 12.5V14m0 6v1.5m6.75-4.5a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0Z",
    stroke: "#08031D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPmCashBlackWhite;